<template>
  <ButtonV2 variant="warning" size="sm" @click="handleClick">
    {{ $t("channel.mvp.multiplier.button") }}
  </ButtonV2>
</template>

<script setup lang="ts">
import {
  ChannelEventType,
  useChannelEvents,
} from "@/composables/channel-events";
import ButtonV2 from "./button-v2.vue";

const { emitChannelEvent } = useChannelEvents();

const emit = defineEmits<{
  click: [];
}>();

const handleClick = () => {
  emitChannelEvent({
    type: ChannelEventType.SHOW_SUPERFAN_MODAL,
  });
  emit("click");
};
</script>
